import { useNavigate } from 'react-router-dom'

import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import BrowserBarPreview from 'modules/core/components/BrowserBarPreview'
import { SITES, SIZES } from 'modules/core/components/BrowserBarPreview/BrowserImage'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const PublicFormSettings = () => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const navigate = useNavigate()

  return (
    <Section
      illustration="folder-file"
      description={i18n.t('app_store_v2.apps.complaints.settings.public_form_settings.description')}
      title={i18n.t('app_store_v2.apps.complaints.settings.public_form_settings.title')}
    >
      <Box
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
        padding="s24"
        gap="s24"
      >
        <BrowserBarPreview
          size={SIZES.big}
          subdomain={company.slug}
          domain={`${company.countryFactorialDomain}/complaints`}
          site={SITES.complaints}
        />
        <Box gap="s16">
          <Text.Normal color="grey1000">
            {i18n.t(
              'app_store_v2.apps.complaints.settings.public_form_settings.change_description'
            )}
          </Text.Normal>
          <Button
            type="secondary"
            onClick={() => navigate(navigation.settings.company_page.fullPath())}
          >
            {i18n.t('app_store_v2.apps.complaints.settings.public_form_settings.change_button')}
          </Button>
        </Box>
      </Box>
    </Section>
  )
}
